import { render } from "./contractDetailExtendCard.vue?vue&type=template&id=e601fc20&ts=true"
import script from "./contractDetailExtendCard.vue?vue&type=script&lang=ts"
export * from "./contractDetailExtendCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__